<script setup lang="ts">
import { ref, watch } from 'vue';
import { patchGroupInHierarchy } from '@/api/GroupApi';
import type { Group } from '@/models/Group';

const props = defineProps<{ isOpen: boolean; group: Group | null }>();
const emit = defineEmits(['update:isOpen']);

const isOpen = ref(props.isOpen);
const editError = ref('');
const group = ref(props.group);

const cancel = () => {
  isOpen.value = false;
  emit('update:isOpen', false);
};

const confirm = async () => {
  if (!group.value) {
    return;
  }
  try {
    await patchGroupInHierarchy(group.value);
    cancel();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error('Failed to update group:', error);
    editError.value = error;
  }
};

watch(
  () => props.isOpen,
  (newVal) => {
    isOpen.value = newVal;
    editError.value = '';
    if (newVal && props.group) {
      group.value = props.group;
    }
  },
);
</script>

<template>
  <v-dialog v-model="isOpen" max-width="600" @click:outside="cancel">
    <v-card>
      <v-card-title>Edit Group</v-card-title>
      <v-card-text>
        <v-form v-if="group">
          <v-text-field
            v-model="group.name"
            :label="$gettext('Name')"
            required
          ></v-text-field>
          <v-textarea
            v-model="group.description"
            :label="$gettext('Description')"
            required
          ></v-textarea>
        </v-form>
        <v-alert v-if="editError" class="mx-2" type="error">{{
          editError
        }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn color="blue darken-1" variant="text" @click="cancel">{{
          $gettext('Close')
        }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" variant="text" @click="confirm">{{
          $gettext('Save')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
